import { ContentBlock, UnwrapPromise } from "@prisma/client";
import invariant from "tiny-invariant";
import { db } from "./db.server";

export type NewContentBlock = Pick<ContentBlock, "slug">;
export type ContentBlockModel = NewContentBlock | ContentBlock;

export function isNewContentBlock(
  block: ContentBlockModel
): block is NewContentBlock {
  return Object.keys(block).length === 1 && typeof block.slug === "string";
}

async function loadBlock(slug: string) {
  return await db.contentBlock.findUnique({
    where: { slug },
    include: { image: true },
  });
}

export async function getContentBlock(
  slug: string
): Promise<ContentBlockModel> {
  const block = await loadBlock(slug);

  if (!block) {
    return { slug };
  }

  return block;
}

export type LoadedContentBlock = Exclude<
  UnwrapPromise<ReturnType<typeof loadBlock>>,
  null
>;
